/*
 *  -----------------------------------------------------------------------
 *    <copyright file="field-helpers.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { RowDataSourceTable } from 'types/graphql-global-types';
import { FieldDefinitionFields } from '@queries/generated/fragments.generated';

export const isFieldType = (field: FieldDefinitionFields, type: RowDataSourceTable) =>
    field.rowDataSource === type || field.dataType === type;

export const isStudyField = (field: FieldDefinitionFields) => isFieldType(field, RowDataSourceTable.STUDY);

export const isSiteField = (field: FieldDefinitionFields) => isFieldType(field, RowDataSourceTable.SITE);

export const isNumericField = (field: FieldDefinitionFields) =>
    field.fieldType === 'INT' || field.fieldType === 'FLOAT';
